var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as rechartComponents from 'recharts';

rechartComponents.Line.defaultProps = _extends({}, rechartComponents.Line.defaultProps, {
    stroke: "var(--primary)"

});

rechartComponents.CartesianGrid.defaultProps = _extends({}, rechartComponents.CartesianGrid.defaultProps, {
    vertical: false,
    stroke: "#f5f5f5"
});

rechartComponents.XAxis.defaultProps = _extends({}, rechartComponents.XAxis.defaultProps, {
    tickCount: 2,
    interval: 1

});

export default rechartComponents;